export default __webpack_public_path__ + "static/media/limit-failure-light.10a73e8c.png";